import React from "react";
import "../css/OutDatedReport.css";
import clockImage from "../assets/h1.png"; // Add a futuristic clock or alert image

const OutDatedReport = () => {
  return (
    <div className="OutdatedReport-wrapper">
      <div className="OutdatedReport-leftPanel">
        <h1 className="OutdatedReport-title">Outdated Report</h1>
        <p className="OutdatedReport-message">
          ⚠️ This page is currently under development.
        </p>
        <p className="OutdatedReport-message">
          Soon, you will be able to track overdue loans, pending repayments, 
          and other outdated financial records in a streamlined, real-time dashboard.
        </p>
        <p className="OutdatedReport-message">
          Our team is adding powerful alerts, timelines, and analytics to help you stay on top of overdue accounts.
        </p>

        <div className="OutdatedReport-alerts">
          <div className="alert red"></div>
          <div className="alert yellow"></div>
          <div className="alert green"></div>
        </div>

        <div className="OutdatedReport-blinkingText">
          🔴 DATA UPDATES COMING SOON
        </div>
      </div>

      <div className="OutdatedReport-rightPanel">
        <img
          src={clockImage}
          alt="Futuristic Clock"
          className="OutdatedReport-image"
        />
      </div>
    </div>
  );
};

export default OutDatedReport;
